<template>
	<div class="popup">
		<div class="popup__top">
			<p class="popup__title">
				<i class="popup__title__icon fas fa-exclamation-circle"></i>
				{{info.title}}
			</p>
			<p class="popup__message">
				{{info.message}}
			</p>
		</div>
		<div class="popup__footer">
			<button class="popup__footer__button--accept" @click="close">Okay</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
	},
	data () {
		return {
		}
	},
	methods: {
		close () {
			this.$store.dispatch('closeModal')
		}
	},
	computed: {
		info () {
			return this.$store.state.modal.content.info
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_popup.scss";
</style>
